var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.043,
    cy: 19.2114,
    r: 16.9848,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.043 3.95508C27.4377 3.95508 34.243 10.7603 34.243 19.1551C34.243 27.5498 27.4377 34.3551 19.043 34.3551C10.6483 34.3551 3.84302 27.5498 3.84302 19.1551C3.84302 10.7603 10.6483 3.95508 19.043 3.95508Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1544 14.3389C25.6648 13.8575 24.9089 13.8355 24.395 14.2622L24.2719 14.3782L17.2624 21.8553L14.2278 18.4883L14.1069 18.3699C13.6012 17.9329 12.8451 17.9398 12.3463 18.4113C11.8476 18.8828 11.7805 19.6541 12.1654 20.2052L12.2711 20.3381L17.2247 25.834L26.1928 16.2668L26.301 16.1361C26.6964 15.5928 26.6441 14.8203 26.1544 14.3389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.24857f7ed70722934d278c9aa1ff40c8.svg";
export { ForwardRef as ReactComponent };